import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia, Button } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { type } from "@testing-library/user-event/dist/type";
import Checkbox from "@mui/material/Checkbox";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import {
  get_YMD_from_SYS,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
  validatedate_min_max,
  get_30DaysBack_FromCurrentDate,
  getlocalstoragedate,
  setlocalstoragedate,
  csvFileName,
  get_YMD_from_DMY,
  getRowData,
} from "../SystemUtility/SystemUtility";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  apiFarmerURL,
  fetchComagentDetail,
  fetchFarmerBillDetail,
} from "./API";
import ResetDate from "../images/resetdate.png";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import MaterialTable from "./CustomTool/MaterialTable";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";

class VepariBillPrint extends Component {
  state = {
    formData: {
      dtpDate: get_YMD_from_SYS(new Date()),
      txtCode: "",
      cmbAgent: "",
    },
    columns: [
      {
        accessorKey: "int_comagentcode",
        header: "વેપારી કોડ",
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 10,
      },
      {
        accessorKey: "vac_comagentname",
        header: "વેપારી નામ",
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 500,
      },
    ],
    rows: [],
    rowsPerPage: 5,
    CommissionAgents: [],
    Item: [],
    agents: [],
    showFields: false, // <-- New flag
    isDateSelected: false, // 👈 for Date field
    fieldsDisabled: true, // 👈 important new flag
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Vepari Bill Report";
    this.props.setActiveMenu("VepariBillPrint");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handles
  handleOnChange = (e) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        // if (
        //   e.target.name == "dtpDate" &&
        //   this.state.formData.dtpDate.length > 0
        // ) {
        if (e.target.name === "dtpDate") {
          if (this.state.formData.dtpDate.length > 0) {
            // this.getComAgent(); // 👈 after selecting date
            // this.onFormLoad();
            this.setState({ showFields: true });
            this.onFormLoad();
          } else {
            // If date cleared, disable fields
            this.setState({ showFields: false });
          }
          // });
        } else if (e.target.name == "txtCode") {
          let itemData = getRowData(
            this.state.CommissionAgents,
            "int_comagentcode",
            e.target.value
          );
          let cmbAgent =
            itemData.length !== 0 ? itemData["vac_comagentname"] : "";

          this.setState({
            formData: {
              ...this.state.formData,
              cmbAgent,
            },
          });
        } else if (e.target.name == "cmbAgent") {
          let itemData = getRowData(
            this.state.CommissionAgents,
            "vac_comagentname",
            e.target.value
          );
          let txtCode =
            itemData.length !== 0
              ? itemData["int_comagentcode"]
              : this.state.formData.txtCode;

          this.setState({
            formData: {
              ...this.state.formData,
              txtCode,
            },
          });
        }
        // else if (e.target.name == "dtpDate" && this.state.formData.dtpDate.length === 0) {
        //   this.setState({ showFields: false });
        // }
      }
    );
  };

  handleARDonActionClick_Delete = (row) => {
    if (!this.state.showFields) return;
    const int_comagentcode = row.getValue("int_comagentcode"),
      vac_comagentname = row.getValue("vac_comagentname");
    this.DeleteData(int_comagentcode, vac_comagentname);
  };

  //#endregion Handles

  //#region Function

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chekNewpage"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateFromToDate = () => {
    let result = false;
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Select Date", "dtpDate");
    } /* else if (this.state.formData.cmbAgent.length <= 0) {
      this.props.toastErrorMsg("Select Commission Agent", "cmbAgent");
    } else if (
      !isValidItem(
        this.state.CommissionAgents,
        "type",
        this.state.formData.cmbAgent
      )
    ) {
      this.props.toastErrorMsg("Select Valid Agent", "cmbAgent");
    }  */ else {
      result = true;
    }
    return result;
  };

  onFormLoad = () => {
    const reqData = {
      Op: "CommissionAgentList",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      dat_inworddate: this.state.formData.dtpDate,
      bol_list: true,
    };

    fetchFarmerBillDetail(reqData)
      .then((res) => {
        this.props.notifyProcessing();

        if (res.data.Message) {
          // 👈 No data found

          this.props.updateProcessing("error", res.data.Message);
          // this.props.updateProcessing('error', "બિલ એન્ટ્રી માટે પસંદગીમાંથી કોઈ ડેટા મળ્યો નથી.");

          this.onRemoveAll();
          this.setState({
            CommissionAgents: [],
            showFields: false,
          });
          return;
        } else {
          // 👈 Data found
          const agents = res.data.CommissionAgentNames || [];
          if (agents.length === 0) {
            this.onRemoveAll();
          } else {
            this.onAddallClick();
          }

          this.onAddallClick();
          this.setState({
            CommissionAgents: agents,
            showFields: agents.length > 0,
          });
          this.onAddallClick();
          this.props.closeUpdateProcessing();
        }
      })
      .catch((err) => {
        console.log("Unknown error occurred in OnFormload.", err);
        this.props.updateProcessing("error", "Unknown error occurred: " + err);
      });

    document.getElementById("dtpDate").focus();
  };

  openInvoice = (bint_acid, bint_acyear, dat_inworddate, vac_companyname) => {
    let rows = this.state.rows;
    console.log("rows", rows);

    if (this.validateFromToDate()) {
      this.props.notifyProcessing();

      // Create a form dynamically
      const form = document.createElement("form");
      form.method = "POST";
      form.action = apiFarmerURL + "farmerbilldetail.php";
      form.target = "SalesList"; // Name of the popup window

      // Helper to add hidden input
      const addField = (name, value) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
      };

      addField("Op", "VepariBillPrint");
      addField("bint_acid", bint_acid);
      addField("bint_acyear", bint_acyear);
      addField("dat_inworddate", dat_inworddate);
      addField("vac_companyname", vac_companyname);
      addField("vepari_data", JSON.stringify(rows)); // send as JSON string

      // Append form to body
      document.body.appendChild(form);

      // Open popup first to avoid popup blockers
      window.open(
        "",
        "SalesList",
        "width=" +
          window.screen.availWidth +
          ",height=" +
          window.screen.availHeight
      );

      // Submit the form
      form.submit();

      // Clean up
      document.body.removeChild(form);

      this.props.updateProcessing("success", "PDF opened in popup.");
    }
  };

  addValidation = () => {
    let result = false;
    if (this.state.formData.txtCode.length <= 0) {
      this.props.toastErrorMsg("વેપારી કોડ દાખલ કરો", "txtCode");
    } else if (this.state.formData.cmbAgent.length <= 0) {
      this.props.toastErrorMsg("વેપારી નામ દાખલ કરો", "cmbAgent");
    } else if (
      !isValidItem(
        this.state.CommissionAgents,
        "vac_comagentname",
        this.state.formData.cmbAgent
      )
    ) {
      this.props.toastErrorMsg("વેપારી નામ દાખલ કરો", "cmbAgent");
    } else {
      result = true;
    }
    return result;
  };

  onAddClick = () => {
    if (this.addValidation()) {
      const { txtCode, cmbAgent } = this.state.formData;

      const newRow = {
        int_comagentcode: txtCode,
        vac_comagentname: cmbAgent,
      };

      const isDuplicate = this.state.rows.some(
        (row) =>
          row.int_comagentcode === newRow.int_comagentcode &&
          row.vac_comagentname === newRow.vac_comagentname
      );

      if (isDuplicate) {
        this.props.toastErrorMsg("This Record Already Exits");
        return;
      } else {
        this.props.toastMsg("success", "Save successfully");

        // Add if not duplicate
        const updatedRows = [...this.state.rows, newRow];

        this.setState({
          rows: updatedRows,
        });
      }
    }
  };

  onAddallClick = () => {
    console.log("this.state.CommissionAgents", this.state.CommissionAgents);
    this.setState({
      rows: this.state.CommissionAgents,
    });
  };

  onRemoveAll = () => {
    this.setState({
      rows: [],
    });
  };

  DeleteData = (int_comagentcode, vac_comagentname) => {
    if (int_comagentcode > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            // alertTitle={
            //   "Do you want Delete to Commission Agent Code :" +
            //   int_comagentcode +
            //   " And Commission Agent Name :" +
            //   vac_comagentname +
            //   " ?"
            // }
            alertTitle={
              " શું તમે કમિશન એજન્ટ કોડ :" +
              int_comagentcode +
              "કમિશન એજન્ટ નામ :" +
              vac_comagentname +
              " વેપારી બિલ પ્રિન્ટ માંથી હટાવા માંગો છો ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteVepariBill(int_comagentcode);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteVepariBill = (int_comagentcode) => {
    let updateRows = this.state.rows.filter(
      (row) => row.int_comagentcode !== int_comagentcode
    );

    this.setState({
      rows: updateRows,
      ARD: null,
    });
  };

  //#endregion Function

  render() {
    return (
      <form>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>વેપરી બિલ પ્રિન્ટ</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          marginTop={0}
        >
          <Grid item>
            <CtDtp
              id="dtpDate"
              label="તારીખ*"
              width="150"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpDate}
              value={this.state.formData.dtpDate}
              onKeyDown={this.props.onKeyDown}
              accountYear={localStorage.getItem("ACY")}
              defaultAction={
                this.state.CommissionAgents.length > 0
                  ? this.onAddallClick
                  : this.onRemoveAll
              }
              nextCtrlID="txtCode"
            />
          </Grid>
          <Grid item marginTop={1}>
            {/* <CtBtn
              label="print"
              onClick={() => {
                this.openInvoice(
                  localStorage.getItem("acid"),
                  localStorage.getItem("ACY"),
                  this.state.formData.dtpDate,
                  localStorage.getItem("CompanyName")
                );
              }}
            /> */}
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                this.openInvoice(
                  localStorage.getItem("acid"),
                  localStorage.getItem("ACY"),
                  this.state.formData.dtpDate,
                  localStorage.getItem("CompanyName")
                );
              }}
              disabled={!this.state.showFields}
            >
              print
            </Button>
          </Grid>
          {/* </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
          marginTop={1}
          spacing={2}
        > */}
          <Grid item>
            <CtTxtNum
              id="txtCode"
              label="વેપારી કોડ*"
              value={this.state.formData.txtCode}
              handleOnChange={this.handleOnChange}
              width={80}
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbAgent"
              disabled={!this.state.showFields} // 👈 Add this
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbAgent"
              label="વેપારી નામ*"
              items={this.state.CommissionAgents}
              colID="vac_comagentname"
              value={this.state.formData.cmbAgent}
              handleOnChange={this.handleOnChange}
              width={300}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.onAddClick}
              disabled={!this.state.showFields} // 👈 Add this
            />
          </Grid>
          <Grid item marginTop={1}>
            <CtBtn
              label="Add"
              onClick={this.onAddClick}
              disabled={!this.state.showFields} // 👈 Add this
            />
          </Grid>
          <Grid item marginTop={1}>
            <CtBtn
              label="Add All"
              onClick={this.onAddallClick}
              disabled={!this.state.showFields} // 👈 Add this
            />
          </Grid>
          <Grid item marginTop={1}>
            <CtBtn
              label="Remove All"
              onClick={this.onRemoveAll}
              disabled={!this.state.showFields} // 👈 Add this
            />
          </Grid>
        </Grid>
        <Grid item marginTop={3} className="maintable">
          <MaterialTable
            rowsdata={this.state.rows}
            columnsdata={this.state.columns}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            // csvFileName={csvFileName("વેપારી પ્રિન્ટ લીસ્ટ")}
            // newBtnClick={this.handleOnNewEntryClick}
            // onEditAction={this.handleARDonActionClick_Edit}
            onDeleteAction={this.handleARDonActionClick_Delete}
            showColumnFilters={false}
            actionColSize={10}
            density={"compact"}
            disabled={!this.state.showFields}

            // toolTipNewEntry="Sales Entry"
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(VepariBillPrint))));
